export default __webpack_public_path__ + "static/images/3be43f6c8f4baaf5fbcbbf92dcc9fb55.png";